import { Environment, isLive } from 'helpers/environment'

const LIVE_BASE_URL = 'https://media.aboutyou.de/cms/'
const STAGING_BASE_URL =
  'https://media-staging-aboutyou-de.s3.eu-west-1.amazonaws.com/cms/'

export const cdnVideoUrl = ({
  pathname,
  environment,
}: {
  pathname?: string | null
  environment: Environment
}) => {
  if (!pathname) {
    return null
  }

  return `${isLive(environment) ? LIVE_BASE_URL : STAGING_BASE_URL}${pathname}`
}
